<div class="object-new-object-view">
  <div class="row object-new-object-view__content">
    @if (selectorContainer && selectorContainer.selectorEnabled) {
      <div
        class="overlay"
        (click)="selectorOverlay()"
        (keydown)="null"
      ></div>
    }

    <app-edit-prime-fields
      [sectionsContainer]="sectionsContainer"
    ></app-edit-prime-fields>
  </div>
</div>
